/*
 Copyright 2016 Aviral Dasgupta

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

import React from 'react';
import {emojifyText} from '../../../HtmlUtils';

export default function EmojiText(props) {
    const {element, children, ...restProps} = props;
    restProps.dangerouslySetInnerHTML = emojifyText(children);
    return React.createElement(element, restProps);
}

EmojiText.propTypes = {
    element: React.PropTypes.string,
    children: React.PropTypes.string.isRequired,
};

EmojiText.defaultProps = {
    element: 'span',
};



// WEBPACK FOOTER //
// ../../../../src/components/views/elements/EmojiText.js